import { computedFrom } from "aurelia-binding";
import { MepLookupItem } from "../../../../../../../../models/mep/mep.models";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { useView } from "aurelia-framework";

@useView('views/pages/modules/mep/tabs/mep-year-over-year-comparison/partials/mep-year-over-year-comparison-year-filter/mep-year-over-year-comparison-year-filter.html')
export class MepYearOverYearComparisonYearFilter {
    years: MepLookupItem[];
    isBaseYear: boolean;
    color: string;

    _selectedYear: MepLookupItem;

    @computedFrom(Reflection.getPropertyPath<MepYearOverYearComparisonYearFilter>(z => z._selectedYear))
    get selectedYear() {
        return this._selectedYear;
    }
    set selectedYear(value: MepLookupItem) {
        this._selectedYear = value;
        if (this.onSelectedYearChanged) {
            this.onSelectedYearChanged();
        }
    }

    constructor(private onSelectedYearChanged: () => void) {
        this.onSelectedYearChanged = onSelectedYearChanged;
    }
}